var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text"},domProps:{"value":_vm.dato},on:{"input":function($event){return _vm.updateData($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }